// JSON-driven layout config for the new dashboard implementation
// You can modify maxColumns and sections to control the layout.
// If sections is empty, the dashboard will render as empty.

const layoutConfig = {
    maxColumns: 24,
    sections: [
        {
            id: "basic-stat-card-example",
            type: "basic-stat-card",
            width: 6,
            initial: { chartid: 111, dashboard_id: 140 },
            statTitle: {
                // path: "apiRow.highchart_code|json2|json|title",
                default: "TOTAL REVENUE",
                icon: "dollar",
                color: "text-[#641C1A]",
                size: "xs"
            },
            props: {
                value: {
                    path: "apiRow.df_data|json2|0.current_year_revenue",
                    format: "currency",
                    prefix: "$",
                    maximumFractionDigits: 0,
                    default: "N/A",
                    visible: true,
                    // Typography controls
                    size: "2xl",
                    fontWeight: "semibold",
                    color: "text-[#0F172A]"
                },
                changePct: {
                    path: "apiRow.df_data|json2|0.growth_percentage",
                    format: "number",
                    default: 7,
                    visible: true,
                    // Typography controls for delta
                    size: "xs",
                    positiveColor: "text-green-600",
                    negativeColor: "text-rose-600"
                },
                comparisonLabel: {
                    default: "v/s last year",
                    visible: true,
                    // Typography controls for comparison label
                    size: "xs",
                    color: "text-[#585858]"
                }
            },
            filters: {
                show: false,
            }
        },
        {
            id: "basic-stat-card-example",
            type: "basic-stat-card",
            width: 6,
            initial: { chartid: 112, dashboard_id: 141 },
            statTitle: {
                path: "apiRow.df_data|json2|0.total_spend",
                default: "MEMBERSHIP REVENUE",
                icon: "dollar",
                color: "text-[#641C1A]",
                size: "xs"
            },
            props: {
                value: {
                    path: "apiRow.df_data|json2|0.current_year_membership_revenue",
                    format: "currency",
                    prefix: "$",
                    maximumFractionDigits: 0,
                    default: "N/A",
                    visible: true,
                    size: "2xl",
                    fontWeight: "semibold",
                    color: "text-[#0F172A]"
                },
                changePct: {
                    path: "apiRow.df_data|json2|0.growth_percentage",
                    format: "percent",
                    default: 0,
                    visible: true,
                    size: "xs",
                    positiveColor: "text-green-600",
                    negativeColor: "text-rose-600"
                },
                comparisonLabel: {
                    default: "v/s last year",
                    visible: true,
                    size: "xs",
                    color: "text-[#585858]"
                }
            }
        },
        {
            id: "basic-stat-card-example",
            type: "basic-stat-card",
            width: 6,
            initial: { chartid: 49, dashboard_id: 55 },
            statTitle: {
                path: "apiRow.df_data|json2|0.total_spend",
                default: "VAS REVENUE",
                icon: "dollar",
                color: "text-[#641C1A]",
                size: "xs"
            },
            props: {
                value: {
                    path: "apiRow.df_data|json2|0.total_spend",
                    format: "currency",
                    prefix: "$",
                    maximumFractionDigits: 0,
                    default: "N/A",
                    visible: true,
                    size: "2xl",
                    fontWeight: "semibold",
                    color: "text-[#0F172A]"
                },
                changePct: {
                    path: "apiRow.df_data|json2|0.change_pct",
                    format: "percent",
                    default: 0,
                    visible: true,
                    size: "xs",
                    positiveColor: "text-green-600",
                    negativeColor: "text-rose-600"
                },
                comparisonLabel: {
                    default: "v/s last year",
                    visible: true,
                    size: "xs",
                    color: "text-[#585858]"
                }
            }
        },
        {
            id: "basic-stat-card-example",
            type: "basic-stat-card",
            width: 6,
            initial: { chartid: 113, dashboard_id: 142 },
            statTitle: {
                path: "apiRow.df_data|json2|0.total_spend",
                default: "RENEWAL REVENUE",
                icon: "dollar",
                color: "text-[#641C1A]",
                size: "xs"
            },
            props: {
                value: {
                    path: "apiRow.df_data|json2|0.current_year_revenue",
                    format: "currency",
                    prefix: "$",
                    maximumFractionDigits: 0,
                    default: "N/A",
                    visible: true,
                    size: "2xl",
                    fontWeight: "semibold",
                    color: "text-[#0F172A]"
                },
                changePct: {
                    path: "apiRow.df_data|json2|0.percentage_increase",
                    format: "percent",
                    default: 0,
                    visible: true,
                    size: "xs",
                    positiveColor: "text-green-600",
                    negativeColor: "text-rose-600"
                },
                comparisonLabel: {
                    default: "v/s last year",
                    visible: true,
                    size: "xs",
                    color: "text-[#585858]"
                }
            }
        },

        // Membership Revenue month wise
        {
            id: "bar-chart-horizontal",
            type: "bar-chart",
            width: 16,
            title: "Membership Revenue",
            initial: {
                chartid: 114,
                dashboard_id: 143
            },
            theme: {
                totalLabel: "Total Spend",
                highlightColor: "#FF8400",
                barColor: "#FFF3E5",
                orientation: "vertical",
                showXAxisLine: true,
                selection: {
                    mode: 'today',
                    unit: 'month',
                }
            },
            props: {
                items: {
                    skip: {
                        key: "month_name",
                        values: ["Total"]
                    },
                }
            },
            meta: {
                primaryValue: {
                    path: 'apiRow.df_data|json2|find([{field:"month_name",value:"Total"}])|revenue',
                    format: 'currency',
                    prefix: "",
                    default: 'N/A',
                    visible: true
                },
                primaryLabel: {
                    path: 'apiRow.data.result.label',
                    format: 'string',
                    default: 'Total Spend',
                    visible: true
                }
            },
            filters: {
                show: true,
                list: [
                    {
                        type: "basic",
                        label: "League",
                        param: ["league"],
                        placement: ["header"],
                        clearable: false,
                        options: [
                            {
                                value: "all",
                                label: "All Leagues",
                            },
                            {
                                value: "luminary-league",
                                label: "The Luminary League",
                            }
                        ],
                    },
                    {
                        type: "date-range",
                        label: "Date Range",
                        param: ["start_date", "end_date"],
                        options: "date-range",
                        placement: ["header"],
                        minDate: "start-of-year",
                        maxDate: "end-of-year",
                    }
                ]
            }
        },

        {
            id: "marketing-spends-progress",
            type: "progress-stat-card",
            width: 8,
            title: "Marketing Spends",
            initial: {
                chartid: 115,
                dashboard_id: 144
            },
            theme: {
                trackColor: 'rgba(148, 163, 184, 0.25)',
                valueFormat: 'currency',
                valuePrefix: '$',
            },
            props: {
                items: {
                    limit: 10,
                    skip: {
                        key: "campaignType",
                        values: ["Total"]
                    },
                    label: "campaignType",
                    value: "cost",
                    maxValue: "budget",
                }
            },
            meta: {
                primaryValue: {
                    path: 'apiRow.df_data|json2|find([{field:"campaignType",value:"Total"}])|total_cost',
                    format: 'currency',
                    prefix: "$",
                    default: 'N/A',
                    visible: true
                },
                delta: {
                    isPercent: true,
                    invert: false,
                    default: 0,
                    visible: false
                }
            },
            filters: {
                show: true,
                list: [
                    {
                        type: "basic",
                        label: "Currency",
                        param: ["currency"],
                        default: "USD",
                        placement: ["header"],
                        options: [
                            {
                                value: "USD",
                                label: "USD",
                            },
                            {
                                value: "EUR",
                                label: "EUR",
                            }
                        ]
                    },
                    {
                        type: "date-range",
                        label: "Date Range",
                        param: ["start_date", "end_date"],
                        options: "date-range",
                        placement: ["meta"],
                        // Keep date range within the current year and limit selectable span to 1 month
                        minDate: "start-of-year",
                        maxDate: "end-of-year",
                        maxRange: { value: 1, unit: "month" },
                        // presets: [
                        //     { label: "Today", value: "today" },
                        //     { label: "This Week", value: "this-week" },
                        //     { label: "This Month", value: "this-month" }
                        // ]
                    }
                ]
            }
        },
        {
            id: "donut-chart-example",
            type: "donut-chart",
            width: 12,
            title: "Value Added Services Breakdown",
            initial: { chartid: 15, dashboard_id: 17 },
            theme: {
                startAngle: -110,
                endAngle: 110,
                hollowSize: '50%',
                legend: false,
                showLabels: false,
                colors: ['#10b981', '#f59e0b', '#3b82f6', '#ef4444']
            },
            meta: {
                primaryValue: {
                    path: 'apiRow.df_data|json2|sum(lead_count)',
                    format: 'currency',
                    prefix: "$",
                    default: 'N/A',
                    visible: true
                },
                primaryLabel: {
                    path: 'apiRow.data.result.label',
                    format: 'string',
                    default: 'Genders',
                    visible: false
                },
                delta: {
                    path: 'apiRow.data.result.changePct',
                    isPercent: true,
                    invert: false,
                    default: 0,
                    visible: true
                },
                legend: 'false' // auto | false | true | { visible: boolean, items: { label: string, labelPath: string, visible: boolean }[] }
            },
            sideMeta: {
                items: [
                    {
                        label: { path: 'apiRow.df_data|json2|0.category', default: 'Category', size: 'xs', color: 'text-[#585858]' },
                        value: { path: 'apiRow.df_data|json2|0.total_spend', format: 'currency', prefix: '$ ', default: 0, size: 'md', color: 'text-green-300' },
                        delta: { path: undefined, isPercent: true, invert: false, default: -10, visible: false }
                    },
                    {
                        label: { default: 'Pay Per Introduction', size: 'xs', color: 'text-[#585858]' },
                        value: { path: 'apiRow.df_data|json2|sum(ppi)', format: 'currency', prefix: '$ ', default: 0, size: 'md', color: 'text-orange-300' }
                    }
                ]
            },
            filters: {
                show: true,
                list: [
                    {
                        type: "date-range",
                        label: "Date Range",
                        param: ["start_date", "end_date"],
                        options: "date-range",
                        placement: ["header"],
                        minDate: "start-of-year",
                        maxDate: "end-of-year",
                    },
                    {
                        type: "basic",
                        label: "League",
                        param: ["league"],
                        placement: ["header"],
                        clearable: false,
                        default: "all",
                        options: [
                            {
                                value: "all",
                                label: "All Memberships",
                            },
                            {
                                value: "premium",
                                label: "Premium",
                            },
                            {
                                value: "standard",
                                label: "Standard",
                            },
                            {
                                value: "basic",
                                label: "Basic",
                            }
                        ],
                    }
                ]
            }

        },
        {
            id: "weekly-report-bar-chart",
            type: "bar-chart",
            width: 7,
            title: "Revenue Growth",
            subtitle: "Weekly Report",
            initial: {
                chartid: 82,
                dashboard_id: 80
            },
            theme: {
                totalLabel: "Total Revenue",
                highlightColor: "rgba(0, 128, 0, 0.8)",
                barColor: "rgba(0, 128, 0, 0.3)",
                orientation: "vertical",
                showBarValues: false,
                showXAxisLabels: true,
                showYAxisLabels: false,
                showXAxisLine: false,
                showYAxisLine: false,
                showGridX: false,
                showGridY: false,

                xAxisKey: "day_of_week",
                yAxisKey: "daily_revenue",

                xAxisKeyFormatter: "first-letter-uppercase",
                selection: {
                    mode: 'today-weekday-index',
                    unit: 'weekday',
                    offset: 1,
                    // API may return Mon/Tue etc.; chart uses first letter labels
                    labelFormatter: 'first-letter-uppercase'
                }
            },
            sideMeta: {
                items: [
                    {
                        value: {
                            path: 'selectedData.row.daily_revenue',
                            format: 'currency',
                            prefix: '$',
                            default: 0,
                        },
                        delta: {
                            path: 'selectedData.row.growth_percentage',
                            isPercent: true,
                            invert: false,
                            default: 0,
                            size: 'md',
                            color: 'text-green-300',
                            visible: true
                        }
                    },
                ]
            },
            filters: {
                show: true,
                list: [
                    // {
                    //     type: "date-range",
                    //     label: "Date Range",
                    //     param: ["start_date", "end_date"],
                    //     options: "date-range",
                    //     placement: ["header"],
                    //     minDate: "start-of-year",
                    //     maxDate: "end-of-year",
                    // },
                    {
                        type: "basic",
                        label: "Week",
                        param: ["week"],
                        placement: ["header"],
                        clearable: false,
                        default: "aug-week-1-2024",
                        options: [
                            {
                                value: "aug-week-1-2024",
                                label: "Aug 1st week 2024",
                            },
                            {
                                value: "aug-week-2-2024",
                                label: "Aug 2nd week 2024",
                            },
                        ],
                    }
                ]
            }
        },
        {
            id: "team-members-grid",
            type: "grid-stat-card",
            width: 5,
            // title: "TEAM MEMBERS",
            statTitle: {
                path: 'apiRow.df_data|json2|0.total_spend',
                default: "TEAM MEMBERS",
                icon: "user",
                color: "text-[#641C1A]",
                size: "xs",
            },
            initial: {
                chartid: 49,
                dashboard_id: 55
            },
            theme: {
                columns: 2,
                valueClass: 'text-2xl font-semibold text-[#0F172A]',
                labelClass: 'text-xs text-[#585858] font-medium',
                gapY: 'gap-y-2',
                gapX: 'gap-x-5',
            },
        },

        {
            id: "members-performance-hybrid",
            type: "chart-list-stat-card",
            width: 24,
            title: "Membership Performance",
            initial: { chartid: 83, dashboard_id: 81 },
            theme: {
                list: {
                    columns: 2,
                    showBars: true,
                    visibility: { label: true, subLabel: true, users: true, split: true, percent: true },
                    itemSpec: {
                        subLabel: { path: 'sublabel', default: "On Website" },
                        split: {
                            variables: {
                                m: { path: 'male_count', default: 0 },
                                f: { path: 'female_count', default: 0 },
                            },
                            display: "${m} M, ${f} F",
                        },
                        label: { path: 'package_name' },
                        users: { path: 'data.total_users', format: 'number', suffix: ' users' },
                        percent: { path: 'data.percentage' }
                    },
                },
                chart: {
                    type: 'donut-chart',
                    theme: {
                        xAxisKey: "package_name",
                        yAxisKey: "total_users",
                        startAngle: 0,
                        endAngle: 360,
                        hollowSize: '65%',
                        legend: false,
                        showLabels: false,
                        center: {
                            title: {
                                path: 'apiRow.df_data|json2|sum(total_users)',
                                format: 'number',
                                maximumFractionDigits: 0,
                                size: '4xl',
                                fontWeight: 500,
                                color: '#1A1A1A',
                                default: 0,
                                visible: true,
                            },
                            subtitle: {
                                path: 'apiRow.data.result.label',
                                default: 'Total',
                                size: 'xl',
                                fontWeight: 600,
                                color: '#989898',
                                visible: true,
                            }
                        }
                    }
                }
            },
            meta: {
                primaryValue: {
                    path: 'apiRow.df_data|json2|sum(total_users)',
                    format: 'currency',
                    prefix: "",
                    default: 'N/A',
                    visible: true
                },
                primaryLabel: {
                    path: 'apiRow.data.result.label',
                    format: 'string',
                    default: 'Total Users',
                    visible: true
                }
            }
        },

        {
            id: "line-chart-example",
            type: "line-chart",
            width: 12,
            title: "Leads to Clients Conversion Rate",
            initial: { chartid: 50, dashboard_id: 55 },
            theme: {
                seriesColors: ['#4F46E5', '#F59E0B'],
                curve: 'smooth',
                showMarkers: false,
            },
            meta: {
                primaryValue: {
                    path: 'apiRow.df_data|json2|0.total_spend',
                    format: 'currency',
                    prefix: "",
                    default: 'N/A',
                    visible: true
                },
                delta: {
                    isPercent: true,
                    invert: false,
                    default: 10,
                    visible: true
                },
                legend: "auto",
            }
        },
        {
            id: "line-chart-example",
            type: "line-chart",
            width: 12,
            title: "SQLs to Clients Conversion Rate",
            delta: {
                isPercent: true,
                invert: false,
                default: 10,
                visible: true,
                description: '(Drop-off rate)'
            },
            initial: { chartid: 50, dashboard_id: 55 },
            theme: {
                seriesColors: ['#4F46E5', '#F59E0B'],
                curve: "straight",
            },
            meta: {
                primaryValue: {
                    path: 'apiRow.df_data|json2|0.total_spend',
                    format: 'currency',
                    prefix: "",
                    default: 'N/A',
                    visible: true
                },
                // delta: {
                //     isPercent: true,
                //     invert: false,
                //     default: 10,
                //     visible: true,
                //     description: '(Drop-off rate)'
                // },
                legend: "auto",
            }
        },
        {
            id: "line-chart-example",
            type: "line-chart",
            width: 12,
            title: "MQLs to Clients Conversion Rate",
            initial: { chartid: 50, dashboard_id: 55 },
            theme: {
                seriesColors: ['cyan', '#F59E0B'],
                curve: 'straight',
            },
            meta: {
                primaryValue: {
                    path: 'apiRow.df_data|json2|0.total_spend',
                    format: 'currency',
                    prefix: "",
                    default: 'N/A',
                    visible: true
                },
                delta: {
                    isPercent: true,
                    invert: false,
                    default: 10,
                    visible: true
                },
                legend: "auto",
            }
        },
        {
            id: "line-chart-example",
            type: "line-chart",
            width: 12,
            title: "Leads to MQLs Conversion Rate",
            initial: { chartid: 50, dashboard_id: 55 },
            theme: {
                seriesColors: ['#4F46E5', '#F59E0B'],
                curve: 'straight',
            },
            meta: {
                primaryValue: {
                    path: 'apiRow.df_data|json2|0.total_spend',
                    format: 'currency',
                    prefix: "",
                    default: 'N/A',
                    visible: true
                },
                delta: {
                    isPercent: true,
                    invert: false,
                    default: 10,
                    visible: true
                },
                legend: "auto",
            }
        },
        {
            id: "line-chart-example",
            type: "line-chart",
            width: 12,
            title: "MQLs to SQLs",
            initial: { chartid: 50, dashboard_id: 55 },
            theme: {
                seriesColors: ['#4F46E5', '#F59E0B'],
                curve: 'straight',
            },
            meta: {
                primaryValue: {
                    path: 'apiRow.df_data|json2|0.total_spend',
                    format: 'currency',
                    prefix: "",
                    default: 'N/A',
                    visible: true
                },
                delta: {
                    isPercent: true,
                    invert: false,
                    default: 10,
                    visible: true
                },
                legend: "auto",
            }
        },
        {
            id: "right-side-stats",
            type: "stack",
            width: 12,
            gap: 3, // gap * 0.25 rem => its tailwind spacing system and in code passed as gap-{gap}
            items: [
                {
                    id: "mqls-stat",
                    type: "basic-stat-card",
                    initial: { chartid: 103, dashboard_id: 131 },
                    statTitle: {
                        default: "MQLs",
                        color: "text-[#1a1a1a]",
                        size: "sm",
                        icon: "none",
                    },
                    props: {
                        value: {
                            path: "apiRow.df_data|json2|0.mql_count",
                            format: "number",
                            default: "1324",
                            visible: true,
                            size: "2xl",
                            fontWeight: "semibold",
                            color: "text-green-600"
                        },
                        comparisonLabel: {
                            default: "07/25 to 08/25",
                            visible: false,
                            size: "xs",
                            color: "text-[#585858]"
                        },
                        changePct: {
                            visible: false,
                        }
                    }
                },
                {
                    id: "sqls-stat",
                    type: "basic-stat-card",
                    initial: { chartid: 49, dashboard_id: 55 },
                    statTitle: {
                        default: "SQLs",
                        color: "text-[#1a1a1a]",
                        size: "sm",
                        icon: "none",
                    },
                    props: {
                        value: {
                            path: "apiRow.df_data|json2|0.sqls",
                            format: "number",
                            default: "1324",
                            visible: true,
                            color: 'text-blue-600',
                            size: "2xl",
                            fontWeight: "semibold",
                        },
                        comparisonLabel: {
                            default: "07/25 to 08/25",
                            visible: false,
                            size: "xs",
                            color: "text-[#585858]"
                        },
                        changePct: {
                            visible: false,
                        }
                    }
                },
                {
                    id: "mql-vs-sql-stat",
                    type: "basic-stat-card",
                    initial: { chartid: 49, dashboard_id: 55 },
                    statTitle: {
                        default: "MQL vs SQL",
                        color: "text-[#1a1a1a]",
                        size: "sm",
                        icon: "none",
                    },
                    props: {
                        value: {
                            path: "apiRow.df_data|json2|0.mql_vs_sql_rate",
                            format: "percent",
                            default: "28%",
                            visible: true,
                            size: "2xl",
                            fontWeight: "semibold",
                            color: "text-purple-600"
                        },
                        comparisonLabel: {
                            default: "07/25 to 08/25",
                            visible: false,
                            size: "xs",
                            color: "text-purple-600"
                        },
                        changePct: {
                            visible: false,
                        }
                    }
                }
            ]
        },
        {
            id: "sbs-example",
            type: "side-by-side-bar-chart",
            width: 12,
            title: "Leads",
            initial: { chartid: 49, dashboard_id: 55 },
            theme: {
                seriesColors: ['#FF8400', '#FFE7CD', '#10B981'] // optional
            },
            meta: {
                primaryValue: {
                    path: 'apiRow.df_data|json2|0.total_spend',
                    format: 'currency',
                    prefix: "",
                    default: 'N/A',
                    visible: true
                },
                delta: {
                    isPercent: true,
                    invert: false,
                    default: 10,
                    visible: true
                },
                legend: "auto",
            }
        },
        {
            id: "line-chart-example",
            type: "line-chart",
            width: 12,
            title: "Revenue",
            initial: { chartid: 52, dashboard_id: 56 },
            theme: {
                seriesColors: ['#4F46E5', '#F59E0B'],
                curve: 'smooth',
                legend: false,
            },
            meta: {
                primaryValue: {
                    path: 'apiRow.df_data|json2|0.total_spend',
                    format: 'currency',
                    prefix: "",
                    default: 'N/A',
                    visible: true
                },
                delta: {
                    isPercent: true,
                    invert: false,
                    default: 10,
                    visible: true
                },
                legend: "auto",
            }
        },
        {
            id: "line-chart-example",
            type: "line-chart",
            width: 24,
            title: "Leads & Source",
            initial: { chartid: 54, dashboard_id: 58 },
            theme: {
                area: true,
                seriesColors: ['#F59E0B', '#4F46E5'],
                curve: 'smooth',
                showMarkers: false,
            },
            inlineMeta: {
                items: [
                    {
                        icon: 'heroicons-outline:chart-square-bar',
                        heading: {
                            path: 'apiRow.df_data|json2|sum(total_spend)',
                            format: 'number',
                            prefix: '',
                            default: 0,
                            color: '#00B822',
                            size: 'xl',
                            fontWeight: 'bold'
                        },
                        subtitle: {
                            default: 'Total Leads',
                            color: '#585858',
                        }
                    },
                    {
                        icon: 'mynaui:line-chart-square',
                        heading: {
                            path: 'apiRow.df_data|json2|0.change_pct',
                            format: 'number',
                            default: 0,
                            color: '#3772FF',
                            size: 'xl',
                            fontWeight: 'bold'
                        },
                        subtitle: {
                            default: 'VFE Insta',
                        }
                    }
                ]
            }
        },
        {
            id: "line-chart-example",
            type: "line-chart",
            width: 24,
            title: "Current Revenue vs Target Revenue",
            initial: { chartid: 50, dashboard_id: 55 },
            theme: {
                seriesColors: ['#4F46E5', '#F59E0B'],
                curve: 'smooth',
            },
            meta: {
                primaryValue: {
                    path: 'apiRow.df_data|json2|0.total_spend',
                    format: 'currency',
                    prefix: "",
                    default: 'N/A',
                    visible: true
                },
                delta: {
                    isPercent: true,
                    invert: false,
                    default: 10,
                    visible: true
                },
                legend: "auto",
            }
        },

        {
            id: "line-chart-example",
            type: "line-chart",
            width: 12,
            title: "Escalations",
            initial: { chartid: 50, dashboard_id: 55 },
            theme: {
                area: true,
                seriesColors: ['#E62400'],
                curve: 'straight',
                showMarkers: false,
            },
            meta: {
                primaryValue: {
                    path: 'apiRow.df_data|json2|0.total_spend',
                    format: 'currency',
                    prefix: "",
                    default: 'N/A',
                    visible: true
                }
            }
        },
        {
            id: "Alliances",
            type: "line-chart",
            width: 12,
            title: "Alliances",
            initial: { chartid: 50, dashboard_id: 55 },
            theme: {
                seriesColors: ['#28C76F'],
                curve: 'smooth',
                showMarkers: false,
            },
            meta: {
                primaryValue: {
                    path: 'apiRow.df_data|json2|0.total_spend',
                    format: 'currency',
                    prefix: "",
                    default: 'N/A',
                    visible: true
                }
            }
        },
        // {
        //     id: "donut-chart-example",
        //     type: "donut-chart",
        //     width: 8,
        //     title: "Introductions made",
        //     initial: { chartid: 15, dashboard_id: 17 },
        //     theme: {
        //         startAngle: 0,
        //         endAngle: 360,
        //         hollowSize: '70%',
        //         legend: false,
        //         showLabels: false,
        //         colors: ['rgba(115, 104, 213, 1)', 'rgba(115, 104, 213, 0.7)', 'rgba(115, 104, 213, 0.5)', 'rgba(115, 104, 213, 0.2)'],
        //         center: {
        //             title: {
        //                 path: 'apiRow.df_data|json2|sum(total_spend)',
        //                 format: 'number',
        //                 maximumFractionDigits: 0,
        //                 size: '2xl',
        //                 fontWeight: 500,
        //                 color: '#7368D5',
        //                 default: 0,
        //                 visible: true,
        //             },
        //             subtitle: {
        //                 path: 'apiRow.data.result.label',
        //                 default: 'Total',
        //                 size: 'xl',
        //                 fontWeight: 600,
        //                 color: '#7368D5',
        //                 visible: true,
        //             }
        //         }
        //     },
        //     meta: {
        //         primaryValue: {
        //             path: 'apiRow.df_data|json2|sum(lead_count)',
        //             format: 'currency',
        //             prefix: "$",
        //             default: 'N/A',
        //             visible: true
        //         }
        //     },
        // },

        {
            id: "sbs-example",
            type: "side-by-side-bar-chart",
            width: 24,
            title: "Deliverables Vs Introductions made",
            initial: { chartid: 49, dashboard_id: 55 },
            theme: {
                seriesColors: ['#59D16F', '#BFEDC8', '#10B981'] // optional
            },
            meta: {
                primaryValue: {
                    path: 'apiRow.df_data|json2|0.total_spend',
                    format: 'currency',
                    prefix: "",
                    default: 'N/A',
                    visible: true
                },
                primaryLabel: {
                    path: 'apiRow.df_data|json2|0.total_spend',
                    format: 'string',
                    default: "(Total Introductions made)",
                    visible: true,
                    size: 'xs',
                    color: '#6A6A6A',
                    weight: 'normal',
                },
                delta: {
                    isPercent: true,
                    invert: false,
                    default: 10,
                    visible: false
                },
                legend: "auto",
            }
        },

        {
            id: "bar-chart-horizontal",
            type: "bar-chart",
            width: 24,
            title: "Renewal / Upgrade Revenue & Percentage",
            initial: {
                chartid: 50,
                dashboard_id: 55
            },
            theme: {
                totalLabel: "Total Spend",
                highlightColor: "#1B7BFF",
                barColor: "#5B8BFF",
                orientation: "vertical",
                selection: {
                    mode: 'position',
                    from: 'last',
                    nth: 1
                }
            },
            inlineMeta: {
                items: [
                    {
                        icon: 'iconoir:dollar-circle',
                        heading: {
                            path: 'apiRow.df_data|json2|0.change_pct',
                            format: 'number',
                            prefix: "$",
                            maximumFractionDigits: 0,
                            default: 0,
                            color: '#5B8BFF',
                            size: 'xl',
                            fontWeight: 'bold'
                        },
                        subtitle: {
                            default: 'Total Revenue',
                        }
                    },
                    {
                        icon: 'solar:hashtag-outline',
                        heading: {
                            path: 'apiRow.df_data|json2|0.change_pct',
                            format: 'number',
                            default: 0,
                            color: '#5B8BFF',
                            size: 'xl',
                            fontWeight: 'bold'
                        },
                        subtitle: {
                            default: 'No. of Renewals',
                        }
                    },
                    {
                        icon: 'mynaui:percentage-square',
                        heading: {
                            path: 'apiRow.df_data|json2|0.change_pct',
                            format: 'percent',
                            default: 15,
                            color: '#5B8BFF',
                            size: 'xl',
                            fontWeight: 'bold'
                        },
                        subtitle: {
                            default: 'Renewal Percentage',
                        }
                    },
                ]
            },
        },
    ],
};

export default layoutConfig;
